import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ExperimentTwoToneSvg from "@ant-design/icons-svg/es/asn/ExperimentTwoTone";
import AntdIcon from "../components/AntdIcon";
var ExperimentTwoTone = function ExperimentTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ExperimentTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ExperimentTwoTone.displayName = 'ExperimentTwoTone';
}
export default /*#__PURE__*/React.forwardRef(ExperimentTwoTone);